<template>
    <div :class="['modal-container', show ? 'active' : '']" >
      <div class="card head-card news modalCharts">
        <div class="title-card" >
          <h4>Buscar cuenta {{ medio == 'FB' ? 'Facebook' : medio == 'TW' ? 'Twitter' : medio == 'PD' ? 'Periodico Digital' : medio == 'Y' ? 'YouTube' : medio == 'TK' ? 'TikTok' : '' }}</h4>
          <button class="touchpad" @click="cancelar">X</button>
        </div>
        <div class="card-content text-center" style="height:200px;">  
            <div class="row justify-content-center">
                <div class="col-sm-12 col-md-8" >
                    <autocomplete :suggestions="availableItems" :selection.sync="value" @selected="handleSelected"></autocomplete>
                </div>
            </div>
        
            <div class="row justify-content-center">
                <div class="col-sm-12 col-md-6" style="margin-top:20px;">
                    <button class="button alternative" style="margin-top:20px;" @click="addFeed" >
                        Agregar
                    </button>
                </div>
            </div> 
        </div>
      </div>
    </div>
</template>

<script>

import Autocomplete from './Autocomplete.vue';
export default {
  components: { Autocomplete },
    name: 'sharBox',
    props:['show', 'medio','ejAction'],
    data() {
        return {
            url: this.$store.getters.getMainUrl,
            value: '',
            availableItems: [],
            itemSelected: null,
        }
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
    },
    watch: {
        medio(newVal) {
            console.log("Medio changed to: " + newVal);
            this.listFeedsX(newVal);
        }
    },
    methods:{
        handleSelected(item) {
            console.log("Selected item:");
            console.log(item);
            this.itemSelected = item;
        },
        /*share(opc){
            this.$emit('share',opc);
        },*/
        cancelar(){
            this.$emit('cancelar');
        },
        listFeedsX(medio){
            var that = this;

            axios.post( that.url+"listFeedsX", JSON.stringify({src: medio}) )
                .then(function(response) {
                if (response.data.success == true) {
                    //console.log(response.data.data);
                    that.availableItems = response.data.data;
                }else{
                    that.error(response.data.error);
                }
                })
                .catch(function(error) {
                console.log("Error");
                console.log(error);
                });
        },
        addFeed(){
            console.log("Add feed: "+this.itemSelected);
            var obj = this.itemSelected;
            var post_data = {
                token: this.token,
                medio: this.medio,
                key: obj,
                fecha: this.$store.state.fecha
            };
            var self = this;
            axios
                //.post(this.url + "addNoticierosToUser", JSON.stringify(post_data))
                .post(this.url + "addNewsToDashboard", JSON.stringify(post_data)) //EGM 241211
                .then(response => {
                if (response.data.success) {
                    self.$emit("reloadSearch");
                    this.$emit('cancelar');
                } else {
                    self.$emit("error", response.data.error);
                }
                })
                .catch(function (error) {
                self.error(error);
                console.log(error);
                });
        },
    },
    //mounted(){
    //    this.listFeedsX();
    //}
}

</script>

